<template>
    <Administrative>
        <Page :submenus="menus"/>
        <div class="-mt-4">
            <BreadcrumbsComponent :pages="pages" :is-dashboard="false"/>
            <div class="grid gap-4 grid-cols-9 -mt-4">
                <div class="col-span-4">
                    <Table :fields="fields"
                           :items="vivas"
                           :canView="true"
                           :empty_message="`Vivas not found`"
                    >
                        <template #viva_at="{item}">
                            {{ tableDate(item.viva_at) }}
                        </template>
                        <template #total="{item}">
                            {{ item.passing_marks }} / {{ item.total_marks }}
                        </template>
                        <template #action="{item}">
                            <inertia-link
                                :href="`${route(`administrative.faculty.view.viva`, [faculty.id,branch.id])}?course=${course_year.id}&item=${item.id}`">
                                <Button>
                                    View Vivas
                                </Button>
                            </inertia-link>
                        </template>
                    </Table>
                </div>
                <div class="col-span-5" v-if="viva">
                    <div class="flex space-x-4 justify-between items-center">
                        <p class="font-semibold text-3xl text-gray-800 leading-tight">{{ viva.title }}</p>
                        <p>Passing Marks {{ viva.passing_marks }} / {{ viva.total_marks }} </p>

                    </div>

                    <Table :fields="studentsFields"
                           :items="students"
                           :canView="true"
                           :empty_message="`Students not found`"
                    >
                        <template #remoark="{item}">
                            <div v-if="item?.submission">
                                {{ item.submission?.remark }}
                            </div>
                            <p v-else>-</p>
                        </template>
                        <template #marks="{item}">
                            <div v-if="item?.submission">
                                {{ item.submission?.marks }} / {{ viva.total_marks }}
                            </div>
                            <p v-else>-</p>
                        </template>
                        <template #name="{item}">
                            <div>
                                {{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}
                                <!--                            <p v-if="item?.submission" class="text-green-600 text-sm mt-1">Submitted on-->
                                <!--                                {{ tableDate(item?.submission?.created_at) }}</p>-->
                                <!--                            <p v-else class="text-red-600 text-sm mt-1">Not submitted yet</p>-->
                            </div>
                        </template>
                        <template #action="{item}">
                            <div class="flex gap-2">

                                <inertia-link
                                    :href="`${route(`internal.admission.view`, [branch.id, item?.admission?.id])}?activeTab=Performance`">
                                    <Button>Performance</Button>
                                </inertia-link>
                            </div>
                        </template>
                    </Table>
                </div>
            </div>
        </div>
    </Administrative>
</template>
<script setup>
import Administrative from "@/Pages/Administrative/Administrative.vue";
import {usePage} from "@inertiajs/inertia-vue3";
import Table from "@/Components/Table.vue";
import Button from "@/Components/Button.vue";
import {computed} from "vue";
import Page from '@/Components/Page'
import {tableDate} from "../../../../../Utils/Common";
import BreadcrumbsComponent from "@/Components/BreadcrumbsComponent.vue";

const vivas = usePage().props.value.vivas ?? [];
const faculty = usePage().props.value?.faculty ?? {};
const branch = usePage().props.value?.branch ?? {};
const viva = usePage().props.value?.viva ?? null;
const course_years = usePage().props.value.course_years ?? [];
const course_year = usePage().props.value?.course_year ?? null;
// const type = usePage().props.value?.type ?? null;
const students = computed(() => {
    let _students = viva?.marked_students ?? [];
    _students = _students.map((item) => {
        const {student, ...rest} = item;
        return {...student, submission: rest}
    })
    return [..._students, ...viva.not_submitted_students];
})
const fields = [
    {'key': 'title', 'label': 'title'},
    {'key': 'total', 'label': 'Passing / Total Marks'},
    {'key': 'viva_at', 'label': 'Date'},
    {'key': 'action', 'label': 'Action'}
];
const studentsFields = [
    {'key': 'name', 'label': 'Student'},
    {'key': 'roll_no', 'label': 'Roll No'},
    {'key': 'marks', 'label': 'Marks'},
    {'key': 'remoark', 'label': 'Remark'},
    {'key': 'action', 'label': 'Action'}
];
const menus = computed(() => {
    return course_years.map((item) => {
        return {
            'title': `${item.title}-${item.course.title}`,
            'active': (course_year.id === item.id),
            'route': `${route(`administrative.faculty.view.viva`, [faculty.id, branch.id])}?course=${item.id}`,
            'visible': true
        };
    })
})
const pages = [
    {name: 'Faculties', href: route('administrative.faculty.list'), current: false},
    {
        name: ` ${faculty.first_name} ${faculty.last_name}`,
        href: route('administrative.faculty.view', faculty.id),
        current: false
    },
    {name: 'Vivas', current: true},
]
</script>
